var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution-add-item-button text-center"},[_c('a-button',{staticClass:"btn-wrap",attrs:{"type":"primary","icon":"plus"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }